"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        var MessageInteractionBuffer = /** @class */ (function () {
            function MessageInteractionBuffer() {
                this.buffer = [];
                this.bufferSize = 5;
                this.currentIndex = 0;
            }
            MessageInteractionBuffer.prototype.advanceBuffer = function () {
                // Circular advancement ... 3 -> 4 -> 0 -> 1 ...
                this.currentIndex = (this.currentIndex + 1) % this.bufferSize;
                // Clear out the next slot
                this.buffer[this.currentIndex] = [];
            };
            MessageInteractionBuffer.prototype.addMessages = function (messages) {
                if (!this.buffer[this.currentIndex]) {
                    this.buffer[this.currentIndex] = [];
                }
                this.buffer[this.currentIndex] = this.buffer[this.currentIndex].concat(messages);
            };
            MessageInteractionBuffer.prototype.getMessagesInOrder = function () {
                var messages = [];
                for (var i = 0; i < this.bufferSize; i++) {
                    var bufferCache = this.buffer[(i + this.currentIndex) % this.bufferSize];
                    if (bufferCache) {
                        messages = messages.concat(bufferCache);
                    }
                }
                return messages;
            };
            return MessageInteractionBuffer;
        }());
        serverForm.MessageInteractionBuffer = MessageInteractionBuffer;
        // Static initialization for QUnit tests; serverForm.init() will re-initialize as required.
        serverForm.messageInteractionBuffer = new MessageInteractionBuffer();
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageInteractionBuffer.js.map
